import React from "react";
import {Link} from "react-router-dom";
import PropTypes from "prop-types";
// JavaScript plugin that hides or shows a component based on your scroll
import Headroom from "headroom.js";
// reactstrap components
import {
    Collapse,
    Button,
    NavbarBrand,
    Navbar,
    NavLink,
    Nav,
    Container,
    Row,
    Col,
} from "reactstrap";
import NavbarLogout from "../../../../../components/Navbars/DefaultNavbar/NavbarLogout";
import {useMeQuery} from "../../../../../store/api/auth";
import MDBox from "../../../../../components/MDBox";
import DefaultNavbarLink from "../../../../../components/Navbars/DefaultNavbar/DefaultNavbarLink";

function DemoNavbar(props) {
    const [collapseOpen, toggleCollapse] = React.useState(false);
    const { data: user } = useMeQuery();

    React.useEffect(() => {
        let headroom = new Headroom(document.getElementById("dark-navbar-main"));
        // initialise
        headroom.init();
    });
    let navbarType = "";
    switch (props.type) {
        case "dark":
            navbarType = "bg-default navbar-dark";
            break;
        case "transparent":
            navbarType = "navbar-transparent";
            break;
        case "primary":
            navbarType = "bg-primary navbar-dark";
            break;
        case "white":
            navbarType = "bg-white";
            break;
        default:
            navbarType = "bg-default navbar-dark";
            break;
    }
    return (
        <>
            <Navbar
                className={"navbar-main headroom " + navbarType}
                expand="lg"
                id="dark-navbar-main"
            >
                <Container>
                    <button
                        className="navbar-toggler"
                        type="button"
                        onClick={() => toggleCollapse(!collapseOpen)}
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <Collapse
                        id="navbar_global"
                        navbar
                        toggler="#navbar_global"
                        isOpen={collapseOpen}
                    >
                        <NavbarBrand className="mr-lg-5" to="/" tag={Link}>
                            <img alt="..." src={require("../../../../../assets/img/brand/logo.png")}></img>
                        </NavbarBrand>

                        <div className="navbar-collapse-header">
                            <Row>
                                <Col className="collapse-brand" xs="6">

                                </Col>
                                <Col className="collapse-close" xs="6">
                                    <button
                                        className="navbar-toggler"
                                        onClick={() => toggleCollapse(!collapseOpen)}
                                    >
                                        <span></span>
                                        <span></span>
                                    </button>
                                </Col>
                            </Row>
                        </div>
                        <Nav
                            className="navbar-nav-hover align-items-lg-center ml-lg-auto"
                            navbar
                        >
                    {/*        <Link to="/authentication/sign-in">*/}
                    {/*            <Button*/}
                    {/*                color="default"*/}
                    {/*                type="button"*/}
                    {/*                // href="http://193.255.88.251:1340/authentication/sign-in"*/}
                    {/*            >*/}
                    {/*<span className="btn-inner--icon">*/}
                    {/*<i className="fas fa-sign-in-alt"></i>*/}
                    {/*</span>*/}
                    {/*                <span className="btn-inner--text"*/}
                    {/*                      color="white"*/}
                    {/*                >LOGIN</span>*/}
                    {/*            </Button>*/}
                    {/*        </Link>*/}
                    {/*        <Link to="/authentication/sign-up">*/}

                    {/*            <Button*/}
                    {/*                color="info"*/}
                    {/*                type="button"*/}
                    {/*            >*/}
                    {/*<span className="btn-inner--icon">*/}
                    {/*<i className="fas fa-user-plus"></i>*/}
                    {/*</span>*/}
                    {/*                <span className="btn-inner--text">SIGN UP</span>*/}
                    {/*            </Button>*/}
                    {/*        </Link>*/}
                                {user && <DefaultNavbarLink icon="donut_large" name="dashboard" route="/dashboard" light={!collapseOpen} />}
                                {user && <DefaultNavbarLink icon="person" name="profile" route="/profile" light={!collapseOpen} />}
                            {/*TODO activate this*/}
                                {/*{!user && (*/}
                                {/*    <DefaultNavbarLink icon="account_circle" name="sign up" route="/authentication/sign-up" light={!collapseOpen} />*/}
                                {/*)}*/}
                                {/*{!user && <DefaultNavbarLink icon="key" name="sign in" route="/authentication/sign-in" light={!collapseOpen} />}*/}
                                {user && <NavbarLogout icon="logout" name="logout" route="/" light={!collapseOpen} />}
                        </Nav>
                    </Collapse>
                </Container>
            </Navbar>
        </>
    );
}

DemoNavbar.defaultProps = {
    type: "dark",
};

DemoNavbar.propTypes = {
    type: PropTypes.oneOf(["dark", "transparent", "primary", "white"]),
};

export default DemoNavbar;
